import { Router, ActivatedRoute } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Component, OnInit, ViewChild, Output, Input } from '@angular/core';
import { LazyLoadEvent, SelectItem, FileUpload } from 'primeng';
import { IPageResult } from '../../interfaces/page-result';
import { ITransactionLine } from '../../interfaces/transaction-line';
import { ITransactionLinesFilter } from '../../interfaces/transaction-lines-filter';
import { TransactionLinesService } from '../../services';

@Component({
  selector: 'transaction-lines-grid',
  templateUrl: './transaction-lines-grid.component.html',
})
export class TransactionLinesGridComponent implements OnInit {
  public manageMode_customer = 1;
  public manageMode_supplier = 2;

  public viewMode_dynamic = 'dynamic';
  public viewMode_static = 'static';
  //---------------

  public page: IPageResult<ITransactionLine> = {
    items: [],
    total: 0,
  };
  public isLoaded: boolean = false;
  public gridInitiated: boolean = false;
  public filterVal: ITransactionLinesFilter;
  public filter: Subject<ITransactionLinesFilter>;

  public get isSupplierMode(): boolean {
    return this.manageMode == this.manageMode_supplier;
  }

  public get isCustomerMode(): boolean {
    return this.manageMode == this.manageMode_customer;
  }

  public get isViewModeDynamic(): boolean {
    return this.viewMode == this.viewMode_dynamic;
  }

  //------- component attributes -------
  private _manageMode: number;
  @Input('manageMode')
  set manageMode(value: number) {
    this._manageMode = value;
  }

  get manageMode(): number {
    return this._manageMode;
  }

  private _supplierInvoiceId: number;
  @Input('supplierInvoiceId')
  set supplierInvoiceId(value: number) {
    this._supplierInvoiceId = value;

    if (this.gridInitiated) {
      this.filterVal.filters.supplierInvoiceId = { value: value };
      this.search();
    }
  }

  get supplierInvoiceId(): number {
    return this._supplierInvoiceId;
  }

  private _viewMode: string = this.viewMode_dynamic;
  @Input('viewMode')
  set viewMode(value: string) {
    this._viewMode = value;
  }

  get viewMode(): string {
    return this._viewMode;
  }

  private _customerInvoiceId: number;
  @Input('customerInvoiceId')
  set customerInvoiceId(value: number) {
    this._customerInvoiceId = value;

    if (this.gridInitiated) {
      this.filterVal.filters.customerInvoiceId = { value: value };
      this.search();
    }
  }

  get customerInvoiceId(): number {
    return this._customerInvoiceId;
  }

  constructor(
    private transactionLinesService: TransactionLinesService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.initDefaultFilter();

    this.filter = new Subject<ITransactionLinesFilter>();
    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
    });
    this.filter.next(this.filterVal);
    this.gridInitiated = true;
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: this.isCustomerMode ? 'OrderNumber' : 'JobNumber',
      sortOrder: 1,
      filters: {
        usePaging: { value: this.isViewModeDynamic },
        customerInvoiceId: { value: this._customerInvoiceId },
        supplierInvoiceId: { value: this._supplierInvoiceId },
        processingStatus: { value: null },
        from: { value: null },
        to: { value: null },
        organisationId: { value: null },
      },
    };
  }

  load(filter: ITransactionLinesFilter) {
    this.transactionLinesService.getPage(filter).then((result) => {
      this.page.items = result.items;
      this.page.total = result.total;
      this.isLoaded = true;
    });
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;
    // map grid lazy load event to filter
    this.filter.next(this.filterVal);
  }

  search() {
    this.filterVal.first = 0; //fix error - when you set page > 1 and filter, then data not display
    this.filter.next(this.filterVal);
  }

  supplierJobScreen(item) {
    this.router.navigate(['app/jobscreen/' + item.jobId]);
  }

  customerJobScreen(item) {
    this.router.navigate(['app/jobscreen/' + item.jobId + '/' + item.orderId]);
  }
}
